import { render, staticRenderFns } from "./AddTeachersToCampaign.vue?vue&type=template&id=6ecff948&scoped=true&"
import script from "./AddTeachersToCampaign.vue?vue&type=script&lang=js&"
export * from "./AddTeachersToCampaign.vue?vue&type=script&lang=js&"
import style0 from "./AddTeachersToCampaign.vue?vue&type=style&index=0&id=6ecff948&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecff948",
  null
  
)

export default component.exports